import { GRADES } from 'Pages/vehicles/helpers/vehicle.schema';

export const ASCENDING_VEHICLE_GRADES_RANK_ORDER = [GRADES.BRONZE, GRADES.SILVER, GRADES.GOLD];
export const DESCENDING_VEHICLE_GRADES_RANK_ORDER = [...ASCENDING_VEHICLE_GRADES_RANK_ORDER].reverse();
